if (document.getElementById("vue-unique-payment")) {
    Vue.use(VeeValidate);
    new Vue({
        delimiters: ["[[", "]]"],
        mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
        el: "#vue-unique-payment",
        data: {
            residentId: null,
            record: {},
            user: {},
            paymentGateway: {},
            articles: [],
            amount: {},
            queryStringParams: {},
            section: {
                labelSubmit: gettext('payer'),
                title: gettext('Vos informations'),
                fields: {
                    full_name: {
                        label: gettext('Prénom et nom du résident'),
                        labelTop: true,
                        labelClasses: 'fw-medium c-gray-600',
                        component: 'input',
                        model: {},
                    },
                    email: {
                        label: gettext('Email'),
                        labelTop: true,
                        labelClasses: 'fw-medium c-gray-600',
                        component: 'input',
                        model: {},
                        validate: 'email'
                    },
                    amount: {
                        label: gettext('Montant à régler'),
                        labelTop: true,
                        labelClasses: 'fw-medium c-gray-600',
                        component: 'input',
                        type: 'number',
                        validate: 'min_value:1|max:7',
                        model: {},
                    },
                    residence: {
                        label: gettext('Votre résidence'),
                        labelTop: true,
                        labelClasses: 'fw-medium c-gray-600',
                        component: 'select',
                        default: gettext('Sélectionner'),
                        options: [],
                        model: {},
                        validateName: gettext('Résidence')
                    },
                },
                config: {
                    rows: [
                        {
                            title: gettext('Remplissez les informations suivantes afin de régulariser votre situation'),
                            titleClasses: 'uppercase fw-medium mb-15 c-gray-800 text-center',
                            classes: 'row-xlarge pb-20 justify-center',
                            cols: [
                                {
                                    classes: 'col-md-4',
                                    // labelClasses: '',
                                    fieldClasses: 'col-12',
                                    fields: [
                                        'full_name',
                                        'email'
                                    ]
                                },
                                {
                                    classes: 'col-md-4',
                                    // labelClasses: '',
                                    fieldClasses: 'col-12',
                                    fields: [
                                        'residence',
                                        'amount',
                                    ]
                                },
                            ],
                        },
                    ]
                }
            }
        },
        created() { },
        mounted() {
            this.getDropdowns();
        },
        computed: {
            renderAmount() {
                if (this.section.fields.amount.model.value) {
                    return this.section.fields.amount.model.value.replace('.', ',') + '€'
                }
            }
        },
        methods: {
            getDropdowns() {
                this.get('dropdowns/instit-residence-list', {}, false)
                    .then((response) => {
                        this.section.fields.residence.options = response.data.map(el => response.data[el] = { label: el.label, value: el.value });
                    });
            },
            createTransaction() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.post('create-transaction', {
                            full_name: this.section.fields.full_name.model.value,
                            email: this.section.fields.email.model.value,
                            residence: this.section.fields.residence.model.value,
                            amount: this.section.fields.amount.model.value,
                            unique: true
                        }).then((response) => {
                            // console.log(response);
                            this.paymentGateway = response.data;
                        }).catch((errors) => {
                            // console.log(error)
                        });
                    }
                })
            },
            getRecords() {
                this.get('residents/' + this.user.id + '/application').then((response) => {
                    this.record = response.data;
                }).catch((error) => {
                    // console.log(error)
                });
            },
        }
    });
}
